import { initializeApp } from 'firebase/app';

/**
 * This is a public api key, no big deal to expose it.
 * It's used to authenticate with Firebase.
 *
 * However it is benefitial to get it from a separate file some time in the future
 * if we need to change the api key based on the environment.
 */
const firebaseConfig = {
  apiKey: 'AIzaSyDJTzYNsYysb-qLTFjZvnonc70WwW-yG-k',
  authDomain: 'auth.glite.ai',
  projectId: 'glitel2',
  storageBucket: 'glitel2.firebasestorage.app',
  messagingSenderId: '663060006997',
  appId: '1:663060006997:web:d118f24dda3402b12fecdc',
  measurementId: 'G-4HBTLPPZBQ',
};

export const firebaseApp = initializeApp(firebaseConfig);
